import React, { Component } from 'react';
import { connect } from 'react-redux';
import CinemapSlider from '../../../../SHARED/components/slider/slider.component';
import { getRecentMoviesSlider } from '../../../../SHARED/actions/movies.actions';
import {Link} from "react-router-dom";
import {slugify} from "../../../../SHARED/helpers/general.helper";

class SliderRecentMoviesContainer extends Component {

    componentWillMount() {
        this.props.getRecentMoviesSlider()
    }

    getSlides() {
        if (this.props.recentMoviesSlider){
            return this.props.recentMoviesSlider.map((item, i) => {
                return {
                    article_title: item.film_title,
                    item_link: `/film/${item.film_id}/${slugify(item.film_title)}`,
                    article_image: item.film_trailer_preview ? item.film_trailer_preview : item.film_image_gallery[0] ? item.film_image_gallery[0] : item.film_poster_orig 
                }
            });
        }
    }

    render() {

        return (
            <div className="slider-recent-movies-container">
                <CinemapSlider slides={this.getSlides()}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    recentMoviesSlider: state.movies.recentMoviesSlider
});
export default connect(mapStateToProps, {getRecentMoviesSlider})(SliderRecentMoviesContainer);



// WEBPACK FOOTER //
// ./src/FO/components/recentmovies/containers/sliderrecentmoviescontainer.component.js